import _classCallCheck from "C:\\Users\\theba\\Documents\\DEVL\\DevilPortalV2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
export var IEvents = function IEvents() {
  _classCallCheck(this, IEvents);
};